import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { ActivityItemsQueryProvider } from "__legacy/queries/activities/ActivityItemsQueryProvider";
import { Button, Input, Layout, notification, PageHeader, Popconfirm, Row, Space, Table, Tabs, Tooltip } from "antd";
import { Fragment, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";

const deleteActivityItemMutation = gql`
  mutation($id: ID!) {
    deleteActivityItem(id: $id) {
      activityItem {
        id
        name
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const { agencyId } = useParams();
  const navigate = useNavigate();
  const [activePane, setActivePane] = useState();

  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const handleSearch = (value: string) => setSearchQuery(value.trim());

  const [execDelete] = useMutation(deleteActivityItemMutation, {
    errorPolicy: "none",
    onError: (error) => {
      notification.error({
        message: error.message,
      });
    },
    onCompleted: ({ deleteActivityItem: { activityItem } }) => {
      notification.success({
        message: `Item "${activityItem.name}" deleted`,
      });
    },
    refetchQueries: ["ActivityItemsQuery"],
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (value: string, resource: any) => <NavLink to={`${resource.id}/edit`}>{value}</NavLink>,
    },
    {
      title: "Kind",
      dataIndex: "kind",
    },
    {
      title: "Balance Kind",
      dataIndex: "balanceKind",
    },
    {
      title: "Assignment",
      dataIndex: "assignment",
    },
    {
      title: "Order",
      dataIndex: "order",
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string) => (
        <Row justify="end">
          <Space>
            <Tooltip title="Edit" placement="bottom">
              <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
            </Tooltip>
            <Popconfirm
              title="Are you sure?"
              icon={<QuestionCircleOutlined />}
              onConfirm={() => execDelete({ variables: { id } })}
            >
              <Tooltip title="Delete" placement="bottom">
                <Button danger icon={<DeleteOutlined />}></Button>
              </Tooltip>
            </Popconfirm>
          </Space>
        </Row>
      ),
    },
  ];

  return (
    <ActivityItemsQueryProvider variables={{ agencyId, kind: activePane, search: searchQuery }}>
      {({ activityItems }) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title="Items"
            extra={
              <Fragment>
                <Input.Search
                  allowClear
                  placeholder="search"
                  onSearch={handleSearch}
                  defaultValue={searchQuery ?? ""}
                  style={{ width: 500 }}
                />
                <Button onClick={() => navigate("new")} type="primary">
                  <PlusOutlined />
                  New
                </Button>
              </Fragment>
            }
            footer={
              <Tabs
                activeKey={activePane}
                onChange={(activeKey: any) => setActivePane(activeKey !== "all" ? activeKey : undefined)}
              >
                <Tabs.TabPane tab="All" key="all" />
                <Tabs.TabPane tab="Cost" key="cost" />
                <Tabs.TabPane tab="Revenue" key="revenue" />
              </Tabs>
            }
          />
          <Layout.Content className="content">
            <Table rowKey="id" columns={columns} dataSource={activityItems} pagination={false} />
          </Layout.Content>
        </Fragment>
      )}
    </ActivityItemsQueryProvider>
  );
};
